"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRTCStatsToVQSStats = void 0;
const convertRTCStatsToVQSStats = (webRTCStats, logger) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const remoteVideoStats = ((_a = webRTCStats.remoteVideoTrackStats) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? webRTCStats.remoteVideoTrackStats[0]
        : undefined;
    const localVideoStats = ((_b = webRTCStats.localVideoTrackStats) === null || _b === void 0 ? void 0 : _b.length) > 0
        ? webRTCStats.localVideoTrackStats[0]
        : undefined;
    if (!remoteVideoStats) {
        logger.debug('no remote video stats');
        return null;
    }
    if (!localVideoStats) {
        logger.debug('no local video stats');
        return null;
    }
    return {
        frameRate: (_c = remoteVideoStats.frameRate) !== null && _c !== void 0 ? _c : 0,
        codec: remoteVideoStats.codec,
        roundTripTime: (_d = localVideoStats.roundTripTime) !== null && _d !== void 0 ? _d : 0,
        bitRate: (_e = remoteVideoStats.bitRate) !== null && _e !== void 0 ? _e : 0,
        height: (_g = (_f = remoteVideoStats.dimensions) === null || _f === void 0 ? void 0 : _f.height) !== null && _g !== void 0 ? _g : 0,
        width: (_j = (_h = remoteVideoStats.dimensions) === null || _h === void 0 ? void 0 : _h.width) !== null && _j !== void 0 ? _j : 0,
        jitterBufferDelay: (_k = remoteVideoStats.jitterBufferDelay) !== null && _k !== void 0 ? _k : 0,
    };
};
exports.convertRTCStatsToVQSStats = convertRTCStatsToVQSStats;
//# sourceMappingURL=remote_video_quality_utils.js.map